import _ from 'lodash'
import {
  buildUrl
} from '@/util'
export default {
  namespaced: true,
  actions: {
    async r ({dispatch, rootState, rootGetters}, options) {
      let key = 'conf'
      let url = options.url
      options.url = buildUrl(rootGetters.rootDomain, key, url, options.query)
      delete options.query

      let res = await dispatch('api/r', options, {root: true})
      if (res.status < 400) {
        return _.get(res, 'data')
      }

      let msg = ''
      let moreInfo = [key, url, res.status]
      if (rootState.env !== 'prod') {
        msg = `请求失败。(${moreInfo.join(', ')})`
      }
      throw new Error(msg)
    },
    async industry ({dispatch}) {
      let data = await dispatch('r', {
        url: '/db/industry.json'
      })
      return data || []
    },
    /**
     * from [{industry_id: 11, name: "智能硬件   ", show: 1, rank: 11}]
     * to [{label: "智能硬件", value: 11}]
     */
    async fixedIndustry ({dispatch}) {
      let data = await dispatch('industry')
      return data
        .filter(row => {
          if (row.show === 1) {
            return true
          }
          return false
        })
        .map(row => {
          return {
            label: _.trim(row.name),
            value: row.industry_id
          }
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/api/conf/index.js